import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const CONVERT_TO_WILL_CALL_ANALYTICS_ACTIONS = {
  trackWillCallModalOpen: createAction(
    '[NgRxClient Analytics] - Track Will Call Modal Open',
    props<{
      tracking: Tracking;
    }>(),
  ),
  trackWillCallModalClose: createAction(
    '[NgRxClient Analytics] - Track Will Call Modal Close',
    props<{
      tracking: Tracking;
    }>(),
  ),
  trackSubmitConvertToWillCallRequest: createAction(
    '[NgRxClient Analytics] - Track Submit Convert To Will Call Request',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
